class AddonToggleController {
  constructor() {
    this.TOGGLE_SELECTOR = ".addon-switch";
    this.ON_CLASS = "is-on";
    this.isRemoving = false;
    this.unlockTimer = null;

    this.handleClick = this.handleClick.bind(this);
    this.syncFromCartDOM = this.syncFromCartDOM.bind(this);
    this.onCartUpdated = this.onCartUpdated.bind(this);
  }

  init() {
    console.log("[addon-toggle] init");

    document.addEventListener("click", this.handleClick, true);

    this.waitForCartDOM().then(() => {
      console.log("[addon-toggle] cart DOM ready");
      this.syncFromCartDOM();
      document.addEventListener("xo:cart:updated", this.onCartUpdated);
    });
  }

  waitForCartDOM() {
    console.log("[addon-toggle] waiting for xo-cart-mini");

    return new Promise((resolve) => {
      const check = () => {
        const cart = document.querySelector("xo-cart-mini");
        if (cart) {
          console.log("[addon-toggle] xo-cart-mini found", cart);
          resolve();
          return;
        }
        requestAnimationFrame(check);
      };
      check();
    });
  }

  onCartUpdated() {
    console.log("[addon-toggle] xo:cart:updated event received");

    this.clearUnlockTimer();
    this.finishRemoval();
    this.syncFromCartDOM();
  }

  lockAllToggles() {
    console.log("[addon-toggle] locking toggles");

    document.querySelectorAll(this.TOGGLE_SELECTOR).forEach((toggle) => {
      toggle.classList.add("is-disabled");
      toggle.setAttribute("aria-disabled", "true");
    });
  }

  unlockAllToggles() {
    console.log("[addon-toggle] unlocking toggles");

    document.querySelectorAll(this.TOGGLE_SELECTOR).forEach((toggle) => {
      toggle.classList.remove("is-disabled");
      toggle.removeAttribute("aria-disabled");
    });
  }

  startUnlockFallback() {
    console.log("[addon-toggle] starting unlock fallback timer");

    this.clearUnlockTimer();

    this.unlockTimer = setTimeout(() => {
      console.warn("[addon-toggle] fallback unlock triggered");
      this.finishRemoval();
    }, 1200);
  }

  clearUnlockTimer() {
    if (this.unlockTimer) {
      console.log("[addon-toggle] clearing unlock timer");
      clearTimeout(this.unlockTimer);
      this.unlockTimer = null;
    }
  }

  finishRemoval() {
    console.log("[addon-toggle] finish removal");
    this.isRemoving = false;
    this.unlockAllToggles();
  }

  syncFromCartDOM() {
    console.log("[addon-toggle] syncing from cart DOM");

    const cartItems = document.querySelectorAll("xo-cart-mini xo-product");
    console.log("[addon-toggle] cart items count:", cartItems.length);

    document.querySelectorAll(this.TOGGLE_SELECTOR).forEach((toggle) => {
      const variantId = toggle.dataset.variantId;
      if (!variantId) return;

      let isInCart = false;

      for (const item of cartItems) {
        const link = item.querySelector("a[href*='variant=']");
        if (!link) continue;

        const url = new URL(link.href);
        if (url.searchParams.get("variant") === variantId) {
          isInCart = true;
          break;
        }
      }

      console.log(
        "[addon-toggle] sync",
        "variant:",
        variantId,
        "isInCart:",
        isInCart,
      );

      toggle.classList.toggle(this.ON_CLASS, isInCart);
      toggle.setAttribute("aria-pressed", String(isInCart));
    });
  }

  removeFromCartByVariant(variantId) {
    if (this.isRemoving) return false;

    const cartItems = document.querySelectorAll("xo-cart-mini xo-product");

    for (const item of cartItems) {
      const link = item.querySelector("a[href*='variant=']");
      if (!link) continue;

      const url = new URL(link.href);
      if (url.searchParams.get("variant") === variantId) {
        const removeBtn = item.querySelector("xo-cart-remove");
        if (!removeBtn) return false;

        this.isRemoving = true;
        this.lockAllToggles();
        this.startUnlockFallback();

        console.log("[addon-toggle] clicking cart remove for", variantId);
        removeBtn.click();
        return true;
      }
    }

    console.warn("[addon-toggle] variant not found in cart", variantId);
    return false;
  }

  handleClick(e) {
    const toggle = e.target.closest(this.TOGGLE_SELECTOR);
    if (!toggle) return;

    console.log("[addon-toggle] toggle clicked", toggle);

    if (this.isRemoving) {
      console.warn("[addon-toggle] click blocked, removal in progress");
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const variantId = toggle.dataset.variantId;
    console.log("[addon-toggle] variantId:", variantId);

    if (!variantId) return;

    const isOn = toggle.classList.contains(this.ON_CLASS);
    console.log("[addon-toggle] current state isOn:", isOn);

    toggle.classList.toggle(this.ON_CLASS, !isOn);
    toggle.setAttribute("aria-pressed", String(!isOn));

    if (isOn) {
      console.log("[addon-toggle] OFF -> remove");
      this.removeFromCartByVariant(variantId);
    } else {
      console.log("[addon-toggle] ON -> add");

      const container = toggle.closest(".product-card-addon__action");
      const addBtn = container?.querySelector(".addon-xo-add");

      if (!addBtn) {
        console.error("[addon-toggle] addon-xo-add not found");
        return;
      }
      // Lock UI before add
      this.isRemoving = true;
      this.lockAllToggles();
      this.startUnlockFallback();
      
      const hadAttr = addBtn.hasAttribute("xo-cart-opened");
      const prevValue = addBtn.getAttribute("xo-cart-opened");

      addBtn.setAttribute("xo-cart-opened", "false");
      console.log("[addon-toggle] clicking xo-cart-add", addBtn);
      addBtn.click();

      requestAnimationFrame(() => {
        if (!hadAttr || prevValue === null) {
          addBtn.removeAttribute("xo-cart-opened");
        } else {
          addBtn.setAttribute("xo-cart-opened", prevValue);
        }
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new AddonToggleController().init();
});
